import { render, staticRenderFns } from "./CompanyDrawerDecisorsTab.vue?vue&type=template&id=23c2588b&"
import script from "./CompanyDrawerDecisorsTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerDecisorsTab.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDrawerDecisorsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports